import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { useSetPosShowSettings } from "@/shared/atoms/usePosShowSettings";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const usePosSettingsAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const isWaiter = useIsWaiter();
  const setShowSettings = useSetPosShowSettings();

  return {
    name: "posSettings" as CurrentActionTypes,
    label: t("posOrders.settings"),
    set: () => setShowSettings((prev) => !prev),
    instantSet: true,
    filtered: false /* !isWaiter */,
    disabled: false,
    iconVariant:"gear",
  };
};

const PosSettingsAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = usePosSettingsAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default PosSettingsAction;
